import { Icon20ExclamationMarkOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import styles from 'reactApp/ui/OverquotaPopup/QuotaSpaceForPromo.css';

interface Props {
    isPrequota?: boolean;
}

export const QuotaSpaceForPromo = memo<Props>(({ isPrequota = false }) => {
    const { used, userTotalSpace } = useSelector(UserQuotaSelectors.getUserQuotaState);
    const { mail: mailUsed, cloud: cloudUsed } = useSelector(UserQuotaSelectors.getUsed);
    const overquota = useSelector(UserQuotaSelectors.getOverQuota);

    const width = Math.round(((mailUsed?.original ?? 0) * 100) / (userTotalSpace?.original || 1));

    return (
        <div className={classNames(styles.quota, { [styles.preQuota]: isPrequota, [styles.quotaMobile]: IS_PHONE_BROWSER })}>
            <div className={styles.quotaIcon}>
                <Icon20ExclamationMarkOutline width={26} height={26} />
            </div>
            <div className={styles.quotaTitle}>
                Занято {used?.value} из {userTotalSpace?.value}
            </div>
            <div className={styles.quotaSeparator}>
                <div className={styles.quotaSeparatorMail} style={{ width: `${width}%` }} />
            </div>
            <div className={styles.quotaText}>
                {isPrequota ? 'Место почти заполнено' : `Пространство переполнено на ${overquota?.value}`}
            </div>
            <div className={styles.quotaSpaces}>
                <div className={styles.quotaSpaceBlock}>
                    <div className={styles.quotaSpaceBlockTitle}>Почта</div>
                    <div>{mailUsed?.value}</div>
                </div>
                <div className={styles.quotaSpaceBlock}>
                    <div className={styles.quotaSpaceBlockTitle}>Облако</div>
                    <div>{cloudUsed?.value}</div>
                </div>
            </div>
        </div>
    );
});

QuotaSpaceForPromo.displayName = 'QuotaSpaceForPromo';
